import axios from "../axios-auth";

export const counterService = {
  getCountersByShopId,
  getCounterList,
  saveCounter,
  getCounterDetail
};

function getCountersByShopId(id) {
  return axios.get("auth/counters-by-shop-id/" + id);
}
function getCounterList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }
  let url = "/auth/all-counter?page=" + page + "&size=" + size + "&sort=" + sortedBy;
  if (searchParams.name) {
    url += "&name=" + searchParams.name;
  }
  if (searchParams.code) {
    url += "&code=" + searchParams.code;
  }
  if (searchParams.shopId) {
    url += "&shopId=" + searchParams.shopId;
  }
  if (searchParams.status) {
    url += "&status=" + searchParams.status;
  }
  return axios.get(url);
}

function saveCounter(counter) {
  if (!counter.id) {
    //new counter
    return axios.post("/auth/counter", counter);
  } else {
    //edit
    return axios.put("/auth/counter", counter)
  }
}

function getCounterDetail(id) {
  return axios.get("/auth/counter/" + id);
}
